import React, { ReactElement, useState } from 'react';
import { StackEntry } from '../BarChart/BarChart.helper';
import CheckField from '../../../shared/components/CheckField/CheckField';
import { CheckboxContainer } from './FilterCheckboxes.styles';

export type FilterCheckboxesParams = {
  stackEntries: StackEntry[][];
  setRemovedEntries: (entries: string[]) => void;
  className?: string;
};

const FilterCheckboxes = ({
  stackEntries, setRemovedEntries, className,
}: FilterCheckboxesParams): ReactElement => {
  const entries = stackEntries.flat();
  const [filteredEntries, setFilteredEntries] = useState([] as string[]);

  return (
    <CheckboxContainer className={className}>
      {entries.map((
        (entry, index) => {
          const onChange = (event: React.FormEvent<HTMLInputElement>): void => {
            const filters = [...filteredEntries];
            if (event.currentTarget.checked) {
              const pos = filters.indexOf(entry.name);
              if (pos >= 0) {
                filters.splice(pos, 1);
              }
            } else {
              filters.push(entry.name);
            }
            setFilteredEntries(filters);
            if (setRemovedEntries) {
              setRemovedEntries(filters);
            }
          };
          return (
            <CheckField
              key={entry.name}
              onChange={onChange}
              type="checkbox"
              name={`filter${index}`}
              value="true"
              label={entry.name}
              checked={!filteredEntries.includes(entry.name)}
            />
          );
        }
      ))}
    </CheckboxContainer>
  );
};

export default FilterCheckboxes;
